/**
 * Formatage des durées de jeu, partagé par le classement et les écrans de jeu :
 * les deux doivent afficher un même chrono à l'identique.
 */

const HOUR = 3600;
const DAY = 24 * HOUR;

/**
 * @param {number|null|undefined} seconds
 * @returns {string} `m:ss` sous l'heure, `2h30` au-delà, `+1j` passé la journée,
 *                   ou un tiret quand la durée n'a jamais été mesurée
 */
export function formatDuration(seconds) {
    if (seconds === null || seconds === undefined) return "–";
    // Garde-fou : au-delà d'une journée, ce n'est plus une partie mais un onglet
    // oublié, et le nombre de chiffres déformerait la colonne.
    if (seconds >= DAY) return "+1j";
    if (seconds >= HOUR) {
        // La mesure réelle est conservée : Country Nerd totalise ses 24 lettres, et
        // une partie de plusieurs heures reste une partie.
        const h = Math.floor(seconds / HOUR);
        const m = Math.floor((seconds % HOUR) / 60);
        return `${h}h${String(m).padStart(2, "0")}`;
    }
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
}
